import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'pact-consumer-session-id';

function safeGet() {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(STORAGE_KEY);
}

export function useConsumerSession() {
  const [sessionId, setSessionId] = useState(() => safeGet());

  useEffect(() => {
    if (sessionId) {
      window.localStorage.setItem(STORAGE_KEY, sessionId);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }, [sessionId]);

  const saveSession = useCallback((value) => {
    setSessionId(value);
  }, []);

  const clearSession = useCallback(() => {
    setSessionId(null);
  }, []);

  return { sessionId, saveSession, clearSession };
}

